export default __webpack_public_path__ + "static/media/Satellite.83e4382e.svg";